import Http from "./base-http";

class Skill extends Http {
  deleteSkill(id) {
    return this.destroy(id);
  }
  addSkill(variables) {
    return this.create(variables);
  }
}

const skillObj = new Skill({
  modelUrlPrefix : "skill"
});

export default skillObj;